import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";
import RoundedCard from "../../../components/RoundedCard/RoundedCard";
import { ReportType } from "../../../store/types/report";
import { Colors } from "../../../utils/constants/style";
import { FolderOpen } from "iconsax-react";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import CreateAFDAEJReportModal from "./CreateAFDAEJReportModal";

const LegalReports: React.FC<{}> = () => {
  const { pushModal } = useModal();
  const setReportType = useStore((state) => state.report.setReportType);
  const adminData = useStore((state) => state.admin.data);
  const openCreateAFDAEJReportModal = () => pushModal(<CreateAFDAEJReportModal />);

  return (
    <div className="mt-4">
      <ShadowBox>
        <div>
          <span className="text-lg font-bold text-dark-blue">Clique para fazer download do relatório desejado</span>
          <div className="flex flex-wrap gap-10 mt-10 mb-5">
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.AFD)
                openCreateAFDAEJReportModal()
              }}
              icon={<FolderOpen size={24} color={Colors.white}/>}
              title="Registros AFD"
              text="Registros AFD da empresa para o período selecionado"
            />
            <RoundedCard
              onClick={() => { 
                setReportType(ReportType.AEJ)
                openCreateAFDAEJReportModal()
              }}
              icon={<FolderOpen size={24} color={Colors.white}/>}
              title="Registros AEJ"
              text="Registros AEJ da empresa para o período selecionado"
            />
          </div>
        </div>
        
      </ShadowBox>
    </div>
  );
};

export default LegalReports;
